<template>
  <main class="reader">
    <!-- <h2>Beamco QR code scanner</h2>
		<hr /> -->

    <!-- 底部弹框 - 成功状态 -->
    <div
      class="result-modal-overlay"
      v-if="showResultModal"
      @click="closeResultModal"
    >
      <div class="result-modal" @click.stop>
        <!-- 拖拽条 -->
        <div class="modal-drag-handle"></div>

        <!-- 成功状态 -->
        <div v-if="res && res.success" class="modal-content success">
          <div class="modal-icon success-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="64"
              height="64"
              viewBox="0 0 64 64"
              fill="none"
            >
              <path
                d="M30.375 42.5C29 43.875 26.875 43.875 25.5 42.5L17.5 34.5C16.125 33.125 16.125 31 17.5 29.625C18.875 28.25 21 28.25 22.375 29.625L28 35.125L41.5 21.625C42.875 20.25 45 20.25 46.375 21.625C47.75 23 47.75 25.125 46.375 26.5L30.375 42.5ZM64 32C64 49.75 49.625 64 32 64C14.25 64 0 49.75 0 32C0 14.375 14.25 0 32 0C49.625 0 64 14.375 64 32ZM32 6C17.625 6 6 17.75 6 32C6 46.375 17.625 58 32 58C46.25 58 58 46.375 58 32C58 17.75 46.25 6 32 6Z"
                fill="#23C16B"
              />
            </svg>
          </div>
          <h3 class="modal-title">{{ res.msg }}</h3>
          <!-- <p class="modal-message">This QR code is valid. The purchase has been verified in our system.</p> -->

          <div class="modal-details">
            <div class="detail-item">
              <span class="detail-label">{{ localeStrings.readerDetailItemHolder }}</span>
              <span class="detail-value">{{
                getHolderName(res.data)
              }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">{{ localeStrings.readerDetailItemName }}</span>
              <span class="detail-value">{{
                getOrderItemName(res.data)
              }}</span>
            </div>
            <div
              class="detail-item"
              v-if="formatOrderItemDetails(res.data) !== '--'"
            >
              <span class="detail-label">{{
                getOrderItemDetailLabel(res.data)
              }}</span>
              <span class="detail-value">{{
                formatOrderItemDetails(res.data)
              }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">{{ localeStrings.readerDetailEmailAddress }}</span>
              <span class="detail-value">{{
                getEmail(res.data)
              }}</span>
            </div>
            <div class="detail-item" v-if="res.data && res.data.checkInTime">
              <span class="detail-label">{{ localeStrings.readerDetailCheckInTime }}</span>
              <span class="detail-value">{{
                formatDateTime(res.data.checkInTime)
              }}</span>
            </div>
          </div>

          <button class="modal-close-btn" @click="closeResultModal">
            {{ localeStrings.readerModalClose }}
          </button>
        </div>

        <!-- 错误状态 -->
        <div v-else-if="err" class="modal-content error">
          <div class="modal-icon error-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="64"
              height="64"
              viewBox="0 0 64 64"
              fill="none"
            >
              <path
                d="M21.875 21.875C23 20.75 24.875 20.75 26 21.875L31.875 27.875L37.875 21.875C39 20.75 40.875 20.75 42 21.875C43.25 23.125 43.25 25 42 26.125L36.125 32L42 37.875C43.25 39.125 43.25 41 42 42.125C40.875 43.375 39 43.375 37.875 42.125L31.875 36.25L26 42.125C24.875 43.375 23 43.375 21.875 42.125C20.625 41 20.625 39.125 21.875 37.875L27.75 32L21.875 26.125C20.625 25 20.625 23.125 21.875 21.875ZM64 32C64 49.75 49.625 64 32 64C14.25 64 0 49.75 0 32C0 14.375 14.25 0 32 0C49.625 0 64 14.375 64 32ZM32 6C17.625 6 6 17.75 6 32C6 46.375 17.625 58 32 58C46.25 58 58 46.375 58 32C58 17.75 46.25 6 32 6Z"
                fill="#FF5247"
              />
            </svg>
          </div>
          <h3 class="modal-title">{{ err.msg }}</h3>
          <!-- <p class="modal-message">{{ getErrorMessage() }}</p> -->

          <div class="modal-details" v-if="err && err.data">
            <div class="detail-item" v-if="err.data.holderName">
              <span class="detail-label">{{ localeStrings.readerDetailItemHolder }}</span>
              <span class="detail-value">{{ getHolderName(err.data) }}</span>
            </div>
            <div class="detail-item" v-if="err.data.orderItem">
              <span class="detail-label">{{ localeStrings.readerDetailItemName }}</span>
              <span class="detail-value">{{ getOrderItemName(err.data) }}</span>
            </div>
            <div
              class="detail-item"
              v-if="formatOrderItemDetails(err.data) !== '--'"
            >
              <span class="detail-label">{{
                getOrderItemDetailLabel(err.data)
              }}</span>
              <span class="detail-value">{{
                formatOrderItemDetails(err.data)
              }}</span>
            </div>
            <div class="detail-item" v-if="err.data.email">
              <span class="detail-label">{{ localeStrings.readerDetailEmailAddress }}</span>
              <span class="detail-value">{{ getEmail(err.data) }}</span>
            </div>
            <div class="detail-item" v-if="err.data.checkInTime">
              <span class="detail-label">{{ localeStrings.readerDetailCheckInTime }}</span>
              <span class="detail-value">{{
                formatDateTime(err.data.checkInTime)
              }}</span>
            </div>
          </div>

          <button class="modal-close-btn" @click="closeResultModal">
            {{ localeStrings.readerModalClose }}
          </button>
        </div>
      </div>
    </div>

    <!-- 成功提示蒙层 -->
    <!-- <div class="success-overlay" v-if="showSuccessModal">
			<div class="success-modal">
				<div class="success-icon">✓</div>
				<h3>Successfully Redeemed</h3>
				<p>The QR code has been successfully marked as redeemed.</p>
				<button class="success-btn" @click="closeSuccessModal">OK</button>
			</div>
		</div> -->

    <!-- 失败提示蒙层 -->
    <!-- <div class="error-overlay" v-if="showErrorModal">
			<div class="error-modal">
				<div class="error-icon">✗</div>
				<h3>Failed Redeemed</h3>
				<p>The QR code redemption failed. Please try again.</p>
				<button class="error-btn" @click="closeErrorModal">OK</button>
			</div>
		</div> -->

    <!-- 扫描蒙层 -->
    <!-- v-if="isScanning" -->
    <div class="scanner-overlay" v-if="isScanning">
      <!-- 摄像头视频背景 -->
      <video
        ref="scannerVideo"
        class="scanner-video-bg"
        autoplay
        playsinline
        webkit-playsinline
        muted
      ></video>

      <!-- 四个蒙层遮罩 -->
      <div class="mask-top"></div>
      <div class="mask-left"></div>
      <div class="mask-right"></div>
      <div class="mask-bottom"></div>

      <!-- 标题 -->
      <div class="scanner-header">
        <button class="close-btn" @click="exitToIndex()" aria-label="Close">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M5.2893 5.2893C5.67503 4.90357 6.30043 4.90357 6.68616 5.2893L12 10.6031L17.3138 5.2893C17.6996 4.90357 18.325 4.90357 18.7107 5.2893C19.0964 5.67503 19.0964 6.30043 18.7107 6.68616L13.3969 12L18.7107 17.3138C19.0964 17.6996 19.0964 18.325 18.7107 18.7107C18.325 19.0964 17.6996 19.0964 17.3138 18.7107L12 13.3969L6.68616 18.7107C6.30043 19.0964 5.67503 19.0964 5.2893 18.7107C4.90357 18.325 4.90357 17.6996 5.2893 17.3138L10.6031 12L5.2893 6.68616C4.90357 6.30043 4.90357 5.67503 5.2893 5.2893Z"
              fill="#F7F9FA"
            />
          </svg>
        </button>
        <div class="scanner-name">{{ scannerName || "Scan QRCode" }}</div>
      </div>

      <!-- 扫描框 -->
      <div class="scanner-frame">
        <div class="corner top-left"></div>
        <div class="corner top-right"></div>
        <div class="corner bottom-left"></div>
        <div class="corner bottom-right"></div>
        <div class="scan-line"></div>
      </div>

      <!-- 底部提示 -->
      <!-- <div class="scanner-tip">
        <p>
          Place the QR code inside the frame, and it will automatically scan.
        </p>
      </div> -->
    </div>

    <canvas class="canvas" ref="canvas"></canvas>
  </main>
</template>

<script>
// https://www.npmjs.com/package/jsqr
// https://www.npmjs.com/package/jimp
import jsQR from "jsqr";
import { scanQrcode } from "@/api/orderQrcodeScanner";
import locales from "@/locales";
import { formatOrderItemDetails as formatQrOrderItemDetails } from "@/utils/qrcodeVariantDetails";

export default {
  name: "Reader",
  data() {
    return {
      timer: null,
      result: "",
      isScanning: false,
      audio: Object,
      video: Object,
      cvsele: Object,
      canvas: Object,
      res: "",
      err: "",
      cameraPermission: null, // 'granted', 'denied', 'prompt'
      cameraStream: null, // 存储摄像头流
      showSuccessModal: false, // 控制成功提示蒙层的显示
      showErrorModal: false, // 控制失败提示蒙层的显示
      showResultModal: false, // 控制结果弹框的显示
      token: "",
      language: "en",
      scannerName: "",
      isProcessing: false, // 当前是否有扫码请求在处理中，避免重复请求
      scanStableData: "", // 最近识别到的二维码内容
      scanStableCount: 0, // 连续识别到相同二维码的次数
    };
  },
  computed: {
    localeStrings() {
      return locales[this.language] || locales.en;
    },
  },
  watch: {
    "$route.query.lang"(newLang) {
      if (newLang && locales[newLang]) {
        this.language = newLang;
        localStorage.setItem("lang", newLang);
      }
    },
  },
  async mounted() {
    this.scannerName = this.$route.query.scannerName;
    // 初始化语言
    const langFromRoute = this.$route.query.lang;
    const storedLang = localStorage.getItem("lang");
    const nextLang = locales[langFromRoute]
      ? langFromRoute
      : locales[storedLang]
      ? storedLang
      : "en";
    this.language = nextLang;
    this.audio = new Audio("../assets/tone.mp3");
    this.video = document.createElement("video");
    this.cvsele = this.$refs.canvas;
    this.canvas = this.cvsele.getContext("2d");
    // this.callApi(
    //   "Z5XrI0kwGl6vuJ2nsyrpQRHUA3AHVFUrgYXn4Joy6+FjsaCCIURvgwmp00eXTFW0kxYOjDnP3FiXRqxWsrAOm34WhVcsMl/cJN0ixvR6gtIKsvtsF1kTmoP84nJLJXw8"
    // );

    // 预先检查摄像头权限
    await this.checkCameraPermission();

    // 自动调用 media() 开始扫描
    this.$nextTick(() => {
      this.media();
    });
  },

  methods: {
    draw(begin, end) {
      this.canvas.beginPath();
      this.canvas.moveTo(begin.x, begin.y);
      this.canvas.lineTo(end.x, end.y);
      this.canvas.lineWidth = 3;
      this.canvas.strokeStyle = "#00ff00";
      this.canvas.stroke();
    },

    // 停止扫描但不导航
    cance() {
      this.isScanning = false;
      cancelAnimationFrame(this.timer);
      // 重置扫描状态
      this.isProcessing = false;
      this.scanStableData = "";
      this.scanStableCount = 0;

      // 停止摄像头流
      if (this.cameraStream) {
        this.cameraStream.getTracks().forEach((track) => track.stop());
        this.cameraStream = null;
      }

      // 清理video元素
      if (this.video.srcObject) {
        this.video.srcObject = null;
      }

      // 清理背景video元素
      this.$nextTick(() => {
        const scannerVideo = this.$refs.scannerVideo;
        if (scannerVideo && scannerVideo.srcObject) {
          scannerVideo.srcObject = null;
        }
      });

      setTimeout(() => {
        this.cvsele.style.display = "none";
      }, 1000);
    },

    // 停止扫描并返回列表页
    exitToIndex() {
      this.cance();
      this.goToIndex();
    },

    async callApi(qrData) {
      try {
        // 重置状态
        this.res = "";
        this.err = "";
        this.showResultModal = false;

        const result = await scanQrcode({
          qrcodeContext: qrData,
        });
        console.log("API调用结果:", result);
        if (result.success) {
          this.res = result;
          this.showResultModal = true;
        } else {
          this.err = result;
          this.showResultModal = true;
        }
        return result;
      } catch (error) {
        console.error("API调用失败:", error);
        console.error("错误详情:", {
          message: error.message,
          name: error.name,
          stack: error.stack,
        });
        this.err = error;
        this.showResultModal = true;
        return null;
      }
    },
    // 简单校验二维码内容是否有效
    isValidQrData(data) {
      if (!data) return false;
      const text = String(data).trim();
      if (!text) return false;
      // 如需更严格校验（例如固定前缀 / 长度），可以在这里加规则
      // 例如：只接受长度大于 10 的内容
      // return text.length > 10;
      return true;
    },

    sweep() {
      if (this.video.readyState === this.video.HAVE_ENOUGH_DATA) {
        const { videoWidth, videoHeight } = this.video;
        this.cvsele.width = videoWidth;
        this.cvsele.height = videoHeight;
        this.canvas.drawImage(this.video, 0, 0, videoWidth, videoHeight);
        try {
          const img = this.canvas.getImageData(0, 0, videoWidth, videoHeight);
          const obj = jsQR(img.data, img.width, img.height, {
            inversionAttempts: "dontInvert",
          });
          // 只有在识别到二维码，并且内容通过校验时，才进一步处理
          if (obj && this.isValidQrData(obj.data)) {
            const loc = obj.location;
            this.draw(loc.topLeftCorner, loc.topRightCorner);
            this.draw(loc.topRightCorner, loc.bottomRightCorner);
            this.draw(loc.bottomRightCorner, loc.bottomLeftCorner);
            this.draw(loc.bottomLeftCorner, loc.topLeftCorner);

            const text = String(obj.data).trim();

            // 连续多帧识别到相同二维码才认为稳定，避免刚举起手机就立即请求
            if (this.scanStableData === text) {
              this.scanStableCount += 1;
            } else {
              this.scanStableData = text;
              this.scanStableCount = 1;
            }

            // 例如：需要连续识别到 3 次相同二维码才触发请求
            if (this.scanStableCount >= 3 && !this.isProcessing) {
              this.isProcessing = true;
              this.audio.play();
              this.result = text;

              // 调用API处理扫描结果，请求完成后停止扫描
              this.callApi(text)
                .finally(() => {
                  this.cance();
                });
            }
          }
        } catch (err) {
          console.error("识别失败:", err);
        }
      }
      if (this.isScanning) {
        this.timer = requestAnimationFrame(() => {
          this.sweep();
        });
      }
    },

    media() {
      this.err = "";
      this.res = "";

      // 如果权限已被拒绝，直接提示用户
      if (this.cameraPermission === "denied") {
        // alert('摄像头权限已被拒绝，请在浏览器设置中允许摄像头访问权限，然后刷新页面重试。');
        alert(
          "Camera permission has been denied. Please enable camera access permission in the browser settings and then refresh the page to try again."
        );
        return;
      }

      // 如果权限已获得，直接开始扫描
      if (this.cameraPermission === "granted") {
        this.startScanning();
        return;
      }

      // 如果权限状态未知或需要提示，请求权限
      this.requestCameraPermission();
    },

    // 开始扫描
    async startScanning() {
      try {
        this.cvsele.style.display = "block";
        const stream = await navigator.mediaDevices.getUserMedia({
          video: { facingMode: "environment" },
        });

        this.cameraStream = stream;
        this.isScanning = true;

        // 设置用于canvas绘制的video
        this.video.srcObject = stream;
        this.video.setAttribute("playsinline", true);
        this.video.setAttribute("webkit-playsinline", true);

        // 设置用于背景显示的video
        this.$nextTick(() => {
          const scannerVideo = this.$refs.scannerVideo;
          if (scannerVideo) {
            scannerVideo.srcObject = stream;
            scannerVideo.setAttribute("playsinline", true);
            scannerVideo.setAttribute("webkit-playsinline", true);
            scannerVideo.play();
          }
        });

        this.video.addEventListener("loadedmetadata", () => {
          this.video.play();
          this.sweep();
        });
      } catch (error) {
        console.error("启动摄像头失败:", error);
        this.cameraPermission = "denied";
        // alert('启动摄像头失败，请检查权限设置。');
        alert(
          "Failed to start the camera. Please check the permission settings."
        );
      }
    },

    // 请求摄像头权限
    requestCameraPermission() {
      this.cvsele.style.display = "block";
      navigator.getUserMedia =
        navigator.getUserMedia ||
        navigator.webkitGetUserMedia ||
        navigator.mozGetUserMedia ||
        navigator.msGetUserMedia;

      if (navigator.mediaDevices) {
        navigator.mediaDevices
          .getUserMedia({
            video: { facingMode: "environment" },
          })
          .then((stream) => {
            // 权限获取成功
            this.cameraPermission = "granted";
            this.cameraStream = stream;
            this.isScanning = true;

            // 设置用于canvas绘制的video
            this.video.srcObject = stream;
            this.video.setAttribute("playsinline", true);
            this.video.setAttribute("webkit-playsinline", true);

            // 设置用于背景显示的video
            this.$nextTick(() => {
              const scannerVideo = this.$refs.scannerVideo;
              if (scannerVideo) {
                scannerVideo.srcObject = stream;
                scannerVideo.setAttribute("playsinline", true);
                scannerVideo.setAttribute("webkit-playsinline", true);
                scannerVideo.play();
              }
            });

            this.video.addEventListener("loadedmetadata", () => {
              this.video.play();
              this.sweep();
            });
          })
          .catch((error) => {
            // 权限被拒绝
            this.cameraPermission = "denied";
            this.isScanning = false;
            this.cance();
            console.log(
              "摄像头权限被拒绝:",
              error.code + "：" + error.name + "，" + error.message
            );
            // alert('需要摄像头权限才能扫描二维码，请允许摄像头访问权限。');
            alert(
              "Camera permission is required to scan QR codes. Please allow camera access permission."
            );
          });
      } else if (navigator.getUserMedia) {
        navigator.getUserMedia(
          {
            video: { facingMode: "environment" },
          },
          (stream) => {
            this.cameraPermission = "granted";
            this.cameraStream = stream;
            this.isScanning = true;

            // 设置用于canvas绘制的video
            this.video.srcObject = stream;
            this.video.setAttribute("playsinline", true);
            this.video.setAttribute("webkit-playsinline", true);

            // 设置用于背景显示的video
            this.$nextTick(() => {
              const scannerVideo = this.$refs.scannerVideo;
              if (scannerVideo) {
                scannerVideo.srcObject = stream;
                scannerVideo.setAttribute("playsinline", true);
                scannerVideo.setAttribute("webkit-playsinline", true);
                scannerVideo.play();
              }
            });

            this.video.addEventListener("loadedmetadata", () => {
              this.video.play();
              this.sweep();
            });
          },
          (error) => {
            this.cameraPermission = "denied";
            this.isScanning = false;
            this.cance();
            // alert('摄像头权限被拒绝：' + error.code + '：' + error.name + '，' + error.message);
            alert(
              "Camera permission has been denied: " +
                error.code +
                "：" +
                error.name +
                "，" +
                error.message
            );
          }
        );
      } else {
        if (
          navigator.userAgent.toLowerCase().match(/chrome/) &&
          location.origin.indexOf("https://") < 0
        ) {
          // alert(
          // 	'获取浏览器录音功能，因安全性问题，需要在localhost 或 127.0.0.1 或 https 下才能获取权限！'
          // );
          alert(
            "Failed to get browser recording function, because of security issues, it can only be obtained in localhost or 127.0.0.1 or https."
          );
        } else {
          this.cance();
          // alert('对不起：未识别到扫描设备!');
          alert("Sorry: No scanning device detected!");
        }
      }
    },

    // 检查摄像头权限
    async checkCameraPermission() {
      try {
        // 检查浏览器是否支持权限API
        if (navigator.permissions) {
          const permission = await navigator.permissions.query({
            name: "camera",
          });
          this.cameraPermission = permission.state;
          console.log("摄像头权限状态:", permission.state);

          // 监听权限状态变化
          permission.onchange = () => {
            this.cameraPermission = permission.state;
            console.log("权限状态变化:", permission.state);
          };
        } else {
          // 如果不支持权限API，尝试直接获取摄像头来检测
          await this.testCameraAccess();
        }
      } catch (error) {
        console.log("权限检查失败，将在用户点击时询问:", error);
        this.cameraPermission = "prompt";
      }
    },

    // 测试摄像头访问
    async testCameraAccess() {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          video: { facingMode: "environment" },
        });
        this.cameraPermission = "granted";
        // 立即停止流，只是为了测试权限
        stream.getTracks().forEach((track) => track.stop());
      } catch (error) {
        this.cameraPermission = "denied";
      }
    },

    // 关闭成功提示蒙层
    closeSuccessModal() {
      this.showSuccessModal = false;
    },

    // 关闭失败提示蒙层
    closeErrorModal() {
      this.showErrorModal = false;
    },

    // 关闭结果弹框
    closeResultModal() {
      this.showResultModal = false;
      this.res = "";
      this.err = "";
      // 返回到 Index 页面
      this.goToIndex();
    },

    // 返回到 Index 页面
    goToIndex() {
      // 从路由查询参数中获取 id 和 token，或从 localStorage 获取
      const id = this.$route.query.id || "";
      const token =
        this.$route.query.token || localStorage.getItem("auth_token") || "";
      const scannerName =
        this.scannerName || this.$route.query.scannerName || "";
      const lang =
        this.$route.query.lang || localStorage.getItem("lang") || "en";

      // 构建查询参数
      const query = {};
      if (id) query.id = id;
      if (token) query.token = token;
      if (scannerName) query.scannerName = scannerName;
      if (lang) query.lang = lang;

      // 导航到 Index 页面
      this.$router.push({
        name: "index",
        query: query,
      });
    },

    // 获取错误信息
    getErrorMessage() {
      if (!this.err)
        return "Failed! We couldn't find a matching record for this QR code.";

      // 如果错误有message字段
      if (this.err.message) {
        return this.err.message;
      }

      // 如果错误有data字段且包含message
      if (this.err.data && this.err.data.message) {
        return this.err.data.message;
      }

      // 如果错误是字符串
      if (typeof this.err === "string") {
        return this.err;
      }

      // 默认错误信息
      return "Failed! We couldn't find a matching record for this QR code.";
    },

    // 格式化日期时间
    formatDateTime(timestamp) {
      if (!timestamp) {
        return "--";
      }
      const date = new Date(
        typeof timestamp === "number" ? timestamp : Number(timestamp)
      );
      if (Number.isNaN(date.getTime())) {
        return timestamp;
      }
      const yyyy = date.getFullYear();
      const mm = String(date.getMonth() + 1).padStart(2, "0");
      const dd = String(date.getDate()).padStart(2, "0");
      const hh = String(date.getHours()).padStart(2, "0");
      const mi = String(date.getMinutes()).padStart(2, "0");
      const ss = String(date.getSeconds()).padStart(2, "0");
      return `${yyyy} - ${mm} - ${dd} ${hh}:${mi}:${ss}`;
    },
    getHolderName(data) {
      return data && data.holderName ? data.holderName : "--";
    },
    getEmail(data) {
      return data && data.email ? data.email : "--";
    },
    getOrderItemName(data) {
      return data && data.orderItem && data.orderItem.name
        ? data.orderItem.name
        : "--";
    },
    formatOrderItemDetails(data) {
      if (!data || !data.orderItem) {
        return "--";
      }
      // 新接口中 bundle 和单品都通过 orderItem.items 返回子商品明细。
      return formatQrOrderItemDetails(data.orderItem);
    },
    getOrderItemDetailLabel(data) {
      const orderItem = data && data.orderItem;
      const isBundle =
        orderItem && (orderItem.type === 2 || orderItem.type === "2");
      return isBundle
        ? this.localeStrings.readerDetailOrderItems
        : this.localeStrings.readerDetailVariantDetails;
    },
  },
};
</script>

<style lang="less">
.reader {
  font-size: 0.8rem;
  position: relative;

  .sweep {
    position: relative;
    margin: 1rem auto;
    padding: 0.6rem;
    width: 8rem;
    font-size: 0.9rem;
    cursor: pointer;
    color: white;
    background: #42b983;
    border: 0.05rem solid #42b983;
    border-radius: 0.4rem;
    overflow: hidden;
    transition: all 0.3s ease;
    display: block;
    box-sizing: border-box;

    &:hover {
      background: #3aa876;
      transform: translateY(-0.1rem);
    }
  }

  .result-display {
    margin: 1rem;
    padding: 0.75rem;
    background: #f8f9fa;
    border-radius: 0.4rem;
    border-left: 0.2rem solid #42b983;

    h3 {
      margin: 0 0 0.5rem 0;
      color: #333;
    }

    p {
      margin: 0;
      word-break: break-all;
      color: #666;
    }

    .result-item {
      display: flex;
      align-items: flex-start;
      margin: 0.4rem 0;
      padding: 0.2rem 0;

      div:first-child {
        width: 4.5rem;
        text-align: left;
        font-weight: bold;
        color: #333;
        margin-right: 0.5rem;
        flex-shrink: 0;
      }

      div:last-child {
        color: #666;
        flex: 1;
        text-align: left;
        word-wrap: break-word;
        word-break: break-word;
        overflow-wrap: break-word;
      }
    }
  }

  .errCss {
    border-left: 0.2rem solid red;
  }

  .success-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0.7);
  }

  .success-modal {
    background-color: white;
    padding: 2rem;
    border-radius: 0.5rem;
    text-align: center;
    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.2);
    max-width: 300px;
    width: 90%;

    .success-icon {
      font-size: 4rem;
      color: #42b983;
      margin-bottom: 0.5rem;
    }

    h3 {
      margin-bottom: 0.5rem;
      color: #333;
    }

    p {
      margin-bottom: 1.5rem;
      color: #666;
      font-size: 0.9rem;
    }

    .success-btn {
      background-color: #42b983;
      color: white;
      padding: 0.6rem 1.5rem;
      border: none;
      border-radius: 0.3rem;
      cursor: pointer;
      font-size: 1rem;
      transition: background-color 0.3s ease;

      &:hover {
        background-color: #3aa876;
      }
    }
  }

  .error-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0.7);
  }

  .error-modal {
    background-color: white;
    padding: 2rem;
    border-radius: 0.5rem;
    text-align: center;
    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.2);
    max-width: 300px;
    width: 90%;

    .error-icon {
      font-size: 4rem;
      color: #dc3545;
      margin-bottom: 0.5rem;
    }

    h3 {
      margin-bottom: 0.5rem;
      color: #333;
    }

    p {
      margin-bottom: 1.5rem;
      color: #666;
      font-size: 0.9rem;
    }

    .error-btn {
      background-color: #dc3545;
      color: white;
      padding: 0.6rem 1.5rem;
      border: none;
      border-radius: 0.3rem;
      cursor: pointer;
      font-size: 1rem;
      transition: background-color 0.3s ease;

      &:hover {
        background-color: #c82333;
      }
    }
  }

  .scanner-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;

    .scanner-video-bg {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
      z-index: 1001;
    }

    .mask-top,
    .mask-left,
    .mask-right,
    .mask-bottom {
      position: absolute;
      background: rgba(0, 0, 0, 0.5);
      z-index: 1002;
    }

    .mask-top {
      top: 0;
      left: 0;
      right: 0;
      height: calc(50vh - 5.125rem);
    }

    .mask-left {
      top: calc(50vh - 5.125rem);
      left: 0;
      bottom: calc(50vh - 1.125rem);
      width: calc(50vw - 3.125rem);
    }

    .mask-right {
      top: calc(50vh - 5.125rem);
      right: 0;
      bottom: calc(50vh - 1.125rem);
      width: calc(50vw - 3.125rem);
    }

    .mask-bottom {
      bottom: 0;
      left: 0;
      right: 0;
      height: calc(50vh - 1.125rem);
    }

    .scanner-header {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      width: 100%;
      z-index: 1003;
      display: flex;
      align-items: center;
      gap: 16px;
      padding: 12px 16px;
      background: linear-gradient(
        180deg,
        rgba(9, 10, 10, 0.48) 0%,
        rgba(9, 10, 10, 0) 100%
      );

      /* bg blur 16% */
      backdrop-filter: blur(8px);
      box-sizing: border-box;

      .scanner-name {
        overflow: hidden;
        color: var(--White-Lightest, #f7f9fa);
        text-align: left;
        text-overflow: ellipsis;

        /* 加粗 21 */
        font-family: var(--app-font-family);
        font-size: 21px;
        font-style: normal;
        font-weight: 700;
        line-height: 30px; /* 142.857% */
        letter-spacing: 1.05px;
      }

      .close-btn {
        background: none;
        border: none;
        cursor: pointer;
        padding: 8px;
        border-radius: 6px;
        transition: background-color 0.3s ease;
        flex-shrink: 0;
        line-height: 1;
        width: 40px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;

        svg {
          display: block;
        }

        &:hover {
          background-color: rgba(255, 255, 255, 0.2);
        }
      }

      h2 {
        margin: 0;
        color: white;
        font-size: 16px;
        font-weight: 500;
        flex: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        min-width: 0;
      }
    }

    .scanner-frame {
      position: relative;
      width: 6.25rem;
      height: 6.25rem;
      z-index: 1003;
      transform: translateY(-2rem);

      .corner {
        position: absolute;
        width: 0.75rem;
        height: 0.75rem;
        border: 0.075rem solid #00ff00;

        &.top-left {
          top: 0;
          left: 0;
          border-right: none;
          border-bottom: none;
        }

        &.top-right {
          top: 0;
          right: 0;
          border-left: none;
          border-bottom: none;
        }

        &.bottom-left {
          bottom: 0;
          left: 0;
          border-right: none;
          border-top: none;
        }

        &.bottom-right {
          bottom: 0;
          right: 0;
          border-left: none;
          border-top: none;
        }
      }

      .scan-line {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 0.05rem;
        background: linear-gradient(90deg, transparent, #00ff00, transparent);
        animation: scan 2s linear infinite;
      }
    }

    .scanner-tip {
      position: absolute;
      bottom: 2rem;
      left: 50%;
      transform: translateX(-50%) translateY(-2rem);
      z-index: 1003;
      text-align: center;
      color: white;
      font-size: 0.4rem;
      padding: 0.25rem;
      background-color: rgba(0, 0, 0, 0.6);
      border-radius: 0.2rem;

      p {
        margin: 0;
        transform: translateY(-0.1rem);
      }
    }
  }

  .canvas {
    display: none;
    box-sizing: border-box;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    object-fit: cover;
  }
}

@keyframes scan {
  0% {
    top: 0;
  }

  100% {
    top: 100%;
  }
}

.result-item {
  display: flex;
  width: 100%;
  justify-content: flex-start;
  align-items: left;
  margin-top: 1rem;

  div:first-child {
    width: 6rem;
    text-align: left;
    font-weight: bold;
  }

  div:last-child {
    text-align: left;
    flex: 1;
  }
}

// 结果弹框样式
.result-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(4px);
  z-index: 2000;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.result-modal {
  width: 100%;
  max-width: 100%;
  max-height: 85vh;
  background: #1e1e1e;
  border-radius: 24px 24px 0 0;
  overflow-y: auto;
  animation: slideUp 0.3s ease;
  position: relative;
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.5);
}

@keyframes slideUp {
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
}

.modal-drag-handle {
  width: 40px;
  height: 4px;
  background-color: rgba(255, 255, 255, 0.3);
  border-radius: 2px;
  margin: 12px auto 20px;
}

.modal-content {
  padding: 0 24px 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.modal-icon {
  margin-top: 24px;
  width: 64px;
  height: 64px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;

  svg {
    width: 100%;
    height: 100%;
  }
}

.success-icon {
  background-color: rgba(76, 175, 80, 0.1);
}

.error-icon {
  background-color: rgba(244, 67, 54, 0.1);
}

.modal-title {
  margin-top: 16px;
  margin-bottom: 24px;
  color: var(--White-Lightest, #f7f9fa);

  /* En/Reg/20 */
  font-family: var(--app-latin-font-family);
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 120% */
  letter-spacing: 0.6px;
  margin: 0 0 12px 0;
  text-align: center;
}

.modal-message {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
  text-align: center;
  margin: 0 0 24px 0;
  line-height: 1.5;
}

.modal-details {
  width: 100%;
  background-color: #191919;
  border-radius: 12px;
  margin-top: 24px;
  padding: 20px;
  margin-bottom: 24px;
  text-align: left;
}

.detail-item {
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;

  &:last-child {
    margin-bottom: 0;
  }
}

.detail-label {
  color: var(--Grey-Lighter, #6c6c72);

  /* En/Reg/14 */
  font-family: var(--app-latin-font-family);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 128.571% */
  letter-spacing: 0.42px;
}

.detail-value {
  color: var(--White-Lightest, #f7f9fa);
  white-space: pre-line;

  /* En/Reg/20 */
  font-family: var(--app-latin-font-family);
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 120% */
  letter-spacing: 0.6px;
}

.modal-close-btn {
  width: 100%;
  border-radius: var(--SM, 8px);
  border: 1px solid var(--Grey-Lighter, #6c6c72);
  display: flex;
  padding: var(--SM, 8px) var(--MD, 16px);
  justify-content: center;
  align-items: center;
  align-self: stretch;
  color: var(--White-Lightest, #f7f9fa);
  background-color: #1e1e1e;

  /* 中等 14 */
  font-family: var(--app-font-family);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px; /* 171.429% */
  letter-spacing: 0.42px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background-color: #353535;
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }
}
</style>
